import union from 'lodash/union';
import { combineReducers } from 'redux';
import { appIntl } from '../../../../utility/context/IntlGlobalProvider';
import Icon from '../../../../utility/icomoon';
import * as types from '../../../types/static-catalogs';

const byId = (state = {}, action) => {
  switch (action.type) {
    //TYPES COMPLETED FETCH, ADD AND EDIT
    case types.LOCATION_CLASSES_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = { ...state };
      order.forEach((locationClassId) => {
        newState[locationClassId] = {
          isSelected: false,
          ...state[locationClassId],
          ...entities[locationClassId],
          isConfirmed: true
        };
      });
      return newState;
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

const order = (state = [], action) => {
  switch (action.type) {
    //CASE COMPLETED FETCH, ADD AND REMOVE
    case types.LOCATION_CLASSES_FETCH_COMPLETED: {
      const { order } = action.payload;
      return union(order);
    }

    //DEFAULT
    default: {
      return state;
    }
  }
};

// STATES TO KNOW IF IT IS FETCHING, ADDING  OR EDITING
const isFetchingList = (state = false, action) => {
  switch (action.type) {
    case types.LOCATION_CLASSES_FETCH_STARTED: {
      return true;
    }
    case types.LOCATION_CLASSES_FETCH_COMPLETED:
    case types.LOCATION_CLASSES_FETCH_FAILED: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const hasAlreadyFetched = (state = false, action) => {
  switch (action.type) {
    case types.LOCATION_CLASSES_FETCH_COMPLETED: {
      return true;
    }
    default: {
      return state;
    }
  }
};

const errorFetchingList = (state = null, action) => {
  switch (action.type) {
    case types.LOCATION_CLASSES_FETCH_FAILED: {
      const { error } = action.payload;
      return error;
    }
    case types.LOCATION_CLASSES_FETCH_STARTED:
    case types.LOCATION_CLASSES_FETCH_COMPLETED: {
      return null;
    }
    default: {
      return state;
    }
  }
};

const locationClasses = combineReducers({
  byId,
  order,
  isFetchingList,
  hasAlreadyFetched,
  errorFetchingList
});

export default locationClasses;

//Own state
export const getOwnState = (state) => state.staticCatalogs.locationClasses;

//Information
export const getLocationClass = (state, locationClassId) =>
  getOwnState(state).byId[locationClassId];

export const getLocationClassIconName = (state, locationClassId) => {
  let lc = getLocationClass(state, locationClassId);
  return lc ? (lc.locationClassIconName ? lc.locationClassIconName : 'MapPin') : 'MapPin';
};
export const getLocationClassDropdownOption = (state, locationClassId) => {
  let lc = getLocationClass(state, locationClassId);
  return lc != undefined
    ? {
        ...lc,
        id: lc.locationClassId,
        value: lc.locationClassId,
        icon: (
          <Icon icon={lc.locationClassIconName} color={lc.locationClassDefaultColor ?? undefined} />
        ),
        label: appIntl().formatMessage({ id: `locations.locationClass.${lc.locationClassId}` })
      }
    : null;
};

export const getLocationClassesList = (state) =>
  getOwnState(state).order.map((id) => getLocationClass(state, id));

//Status of sagas
export const isFetchingListLocationClasses = (state) => getOwnState(state).isFetchingList;
export const haveLocationClassesBeenFetched = (state) => getOwnState(state).hasAlreadyFetched;

//Errors
export const getFetchingListLocationClassesErrors = (state) => getOwnState(state).errorFetchingList;
